import styled from "styled-components";
import { provideIsLoadingProp, } from "@/utils/context/LoadingContext";
export const CheckoutSectionText = styled.p.attrs(provideIsLoadingProp) ``;
